import React from 'react'
import Header from './Header'
// import Footer from './Footer'
import ToastMessages from './ToastMessages'
import { Toaster } from 'sonner'
import MainContent from '@/components/Shared/MainContent'

const Layout = (props) => {
  return (
    <div className='app side-nav-outer-toolbar'>
      <Header
        menuToggleEnabled
      />

      <MainContent fullGrid={props.fullGrid}>
        {props.children}
      </MainContent>

      {/* <Footer /> */}

      <Toaster
        position='top-right'
        // richColors
        duration={2000}
        closeButton
      />

      <ToastMessages />
    </div>
  )
}

export default Layout
